module.exports = __webpack_public_path__ + "img/glassquality_5.86cb4fe0.png";